import { Component } from 'react'
import { parse, stringify } from 'query-string'

import Layout from './containers/Layout'
import CustomProviders from './context/custom-providers'
import { pushLoginLimitMessage } from './utils/userAuth'
import OnboardingModalPortal from './features/onboarding/components/modal/onboarding-modal-portal'
import PaywallPortal from './features/paywall/components/paywall-portal'
import './utils/sentry'

class App extends Component {
  componentDidMount() {
    const script = document.createElement('script')
    script.async = true
    script.defer = true
    script.src = 'https://www.google.com/recaptcha/api.js'
    document.body.appendChild(script)

    const parsed = parse(window.location.search)
    if (parsed.fresh_login === 'false') {
      pushLoginLimitMessage()
      delete parsed.fresh_login
      window.location.href = `${window.location.pathname}?${stringify(parsed)}`
    }
  }

  render() {
    const { injectReducer, injectSaga } = this.props

    return (
      <CustomProviders>
        <Layout injectReducer={injectReducer} injectSaga={injectSaga} />
        <OnboardingModalPortal />
        <PaywallPortal />
      </CustomProviders>
    )
  }
}

export default App
